import React from "react";
import {Form} from 'react-bootstrap';

function STCFormText(props){

    return(
        <Form.Text
            style={props.style}
            className={props.className}

            ref={props.ref}
            as={props.as}
            muted={props.muted}
            bsPrefix={props.bsPrefix}
        >
            {props.children}
        </Form.Text>
    )
}
export default STCFormText;